<div *appSpinner="loading; diameter: 40; color: 'primary'"></div>
<div *ngIf="protestInfo" class="epds_mat_override">
  <mat-card>
    <mat-card-content>
      <div class="indent"></div>
      <table aria-label="Table with Case information" role="presentation" fxFlex>
        <colgroup>
          <col style="width: 200px;">
          <col>
        </colgroup>
        <tbody>
        <tr>
          <td><span><strong>Protester</strong></span></td>
          <td><span>{{ protestInfo.company_Name }}</span></td>
        </tr>
        <tr>
          <td><span><strong>B-Number</strong></span></td>
          <td>
                <span [ngClass]="{ 'pending-entry color_warn': !protestInfo.b_No  }"
                      [matTooltip]="protestInfo.a_No">
                  {{ protestInfo.b_No || "pending" }}
                </span>
          </td>
        </tr>
        <tr>
          <td><span><strong>Consolidated Protests</strong></span></td>
          <td>
            <span *ngFor='let childProtestInfo of protestInfo.listOf_ConsolidatedProtest_Info; index as i'>
              {{ childProtestInfo.company_Name | uppercase }}&nbsp;&nbsp;,&nbsp;&nbsp;{{ childProtestInfo.b_No }}
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-content fxLayout="column" fxLayoutAlign="start start">
      <div fxFill>
        <div class="indent"></div>
        <div fxFlex>

          <div>
            <strong>Enter the Case Number (Ex: B-XXXXXX.XX) which you need to join/unjoin to the current case.</strong><br/><br/>
          </div>

          <form [formGroup]="joinUnjoinForm">

            @for (controlName of Object.keys(joinUnjoinForm.controls); track controlName; let index = $index; let count = $count) {
              <div style="margin-bottom: 8px;">
                <mat-form-field floatLabel="always" appearance="outline" class="search-field">
                  <mat-label>B# {{ index + 1 }}</mat-label>
                  <input matInput type="text"
                         [name]="controlName"
                         [formControlName]="controlName" />
                  @if (joinUnjoinForm.get(controlName)?.dirty && joinUnjoinForm.get(controlName)?.invalid && joinUnjoinForm.get(controlName)?.errors?.['error']) {
                    <mat-error>
                      {{ joinUnjoinForm.get(controlName)?.errors?.['error'] }}
                    </mat-error>
                  }
                </mat-form-field>

                @if (index === 0) {
                  <button mat-raised-button
                          color="primary" class="spinner-black"
                          [disabled]="busy"
                          (click)="onAdd()">
                    Add
                  </button>
                } @else {
                  <button mat-raised-button
                          color="warn" class="spinner-black"
                          [disabled]="busy"
                          (click)="onRemove(controlName)">
                    Remove
                  </button>

                }
              </div>
            }
          </form>

          <div class="controls">
            <button mat-raised-button
                    color="primary" class="spinner-black"
                    [disabled]="!joinUnjoinForm.valid || !joinUnjoinForm.dirty || busy || checkAllFieldsDirty()"
                    (click)="onJoin()">
              <div *appSpinner="busy"></div>
              Join
            </button>

            <button mat-raised-button
                    color="primary" class="spinner-black"
                    [disabled]="!joinUnjoinForm.valid || !joinUnjoinForm.dirty || busy || checkAllFieldsDirty()"
                    (click)="onUnJoin()">
              <div *appSpinner="busy"></div>
              Unjoin
            </button>
          </div>

        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
